const zh = {
  message: {
    amountValidate: '请输入大于0的数字',
  },
};

export default zh;
